export interface ISiteMapStructure {
  id: string
  site: {
    site_id: string
    name: string
  }
  tenant_id: string
  name: string
  foreman_id: number | null
  created_at: string
  deactivated_at: string | null
  updated_at: string
  operational: boolean
  racks: {
    name: string
    operational: boolean
  }[]
}

export interface ISiteMapRack {
  id: string
  site: {
    site_id: string
    name: string
  }
  structure: {
    id: string
    name: string
  }
  tenant_id: string
  name: string
  foreman_id: number | null
  created_at: string
  deactivated_at: string | null
  updated_at: string
  operational: boolean
  miners: {
    name: string
    ip: string
    model: string
  }[]
}

export interface ISiteMapMiner {
  id: string
  site: {
    site_id: string
    name: string
  }
  structure: {
    id: string
    name: string
  }
  rack: {
    id: string
    name: string
  }
  hosting_client: {
    id: string
    name: string
  }
  tenant_id: string
  name: string
  foreman_id: number | null
  ip: string | null
  model: string
  tags: string[]
  last_hashrate_value?: number | null
  last_hashrate_timestamp?: string | null
  updated_at: string
}

export interface IHostingClient {
  id: string
  tenant_id: string
  name: string
  foreman_id: number | null
  foreman_name: string | null
  miners_under_contract: number
  total_registered_miners: number | null
  online_miners: number | null
  offline_miners: number | null
  pending_miners: number | null
  disabled_miners: number | null
  hashing_miners: number | null
  sleeping_miners: number | null
  deployed_miners: number | null
  in_repair_miners: number | null
  uptime_threshold_percentage: number
  updated_at: string
}

export enum InfrastructureType {
  SITE = 'Site',
  STRUCTURE = 'Structure',
  RACK = 'Rack',
}
